import { useState } from 'react';

/**
 * Local state that follows the stored value, except while the user is editing
 * (so a save round-trip never overwrites what is being typed). Spread `focus`
 * on the element (or wrapper) that is being edited.
 */
export function useSynced<T>(value: T) {
  const [state, setState] = useState(value);
  const [seen, setSeen] = useState(value);
  const [editing, setEditing] = useState(false);
  if (seen !== value && !editing) {
    setSeen(value);
    setState(value);
  }
  const focus = { onFocus: () => setEditing(true), onBlur: () => setEditing(false) };
  return [state, setState, focus] as const;
}
